export default {
  getLastVisitedRoute: ({ navigationHistory }) => navigationHistory.lastVisitedRoute,
};
